
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 10 4","width":"10","height":"4"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 2h6","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round"}})])
          )
        }
      }
    